import { Pages } from "./types";

export const enum AnalyticsPageDashboard {
  Dashboard = "Dashboard",
}

export const pagesDashboard: Pages<AnalyticsPageDashboard> = {
  [AnalyticsPageDashboard.Dashboard]: ["Dashboard"],
};
